export default __webpack_public_path__ + "static/media/whitepaperfive.8c7da6a9.png";